document.addEventListener('DOMContentLoaded', () => {
  const setLangId = () => {
    const lang = document.documentElement.lang || '';

    // en-US → en、zh-CN → zh のように先頭の言語コードだけ取得
    const langCode = lang.split('-')[0];

    if (langCode) {
      document.body.id = langCode;
    }
  };

  setLangId();

  const observer = new MutationObserver(setLangId);

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang'],
  });
});